import React, { Component } from "react";
import axios from "axios";
import $ from "jquery";
import Header from "./Header";
import SideBar from "./SideBar";
import Chart from "chart.js/auto";
import Data from "./Data";
import Classes2 from "./Classes2";
import { CircularProgress } from "@material-ui/core";
import { useSnackbar } from "notistack";
import ClassesPanelList from "./ClassesPanelList";
import { useState, useEffect } from "react";
import { Input, Loading, Radio, Spacer } from "@nextui-org/react";
import InfiniteScroll from "react-infinite-scroller";
import { useSelector, useDispatch } from "react-redux";
import { classesActions } from "../Store/classesSlice";
import { BiSearchAlt } from "react-icons/bi";

function ClassesPanel(props) {
  const dispatch = useDispatch();
  const articles = useSelector((state) => state.classes.items);
  const nextPage = useSelector((state) => state.classes.nextPage);
  const hasMore = useSelector((state) => state.classes.hasMore);
  const length = useSelector((state) => state.classes.length);
  const search = useSelector((state) => state.classes.search);
  const day = useSelector((state) => state.classes.day);
  const dayid = useSelector((state) => state.classes.dayid);

  let myRef = null;
  let loader = null;
  const setMyRefRef = (element) => {
    myRef = element;
  };
  const setMyLoader = (element) => {
    loader = element;
  };

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    dispatch(classesActions.setLoading(length - articles.length > 0));
    if (articles.length >= parseInt(length) && articles.length !== 0) {
      $("#loading").addClass("invisible");
    } else {
      $("#loading").removeClass("invisible");
    }
  }, [articles]);
  useEffect(() => {
    dispatch(classesActions.empty());
  }, [dayid]);

  const changeDay = (day) => {
    dispatch(classesActions.setDay(day));
  };

  const handleLoadMore = () => {
    let token = localStorage.getItem("token");
    let data = new FormData();
    let st = " id != ''";

    data.append("token", token);
    data.append("how", "10");
    data.append("count", nextPage);
    data.append("dayid", dayid);
    data.append("if", st);
    data.append("search", search);
    dispatch(classesActions.setLoading(false));

    axios
      .post(Data.mainserver + `/getClasses5.php`, data)
      .then((response) => {
        console.log(response.data);
        $("#waitspinner").modal("hide");
        $("#progressTop").addClass("invisible");
        if (
          response.data.hasOwnProperty("data") &&
          response.data.hasOwnProperty("length") &&
          response.data.hasOwnProperty("row")
        ) {
          $("#masters").removeClass("invisible");

          const lengthh = response.data.length;
          const { row, data } = response.data;
          dispatch(
            classesActions.addItems({
              lengthh: lengthh,
              row: row,
              data: data,
            })
          );
        }
        if (response.data.hasOwnProperty("no_item")) {
          $("#no_item").removeClass("invisible");
        }
        $("#select_instrument").removeClass("invisible");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // const handleChange=(event)=>{
  //     const target = event.target;
  //     setFields({
  //         ...fields,
  //         [target.name] : target.value
  //     });
  // }

  useEffect(() => {
    document.title = "کلاس ها - پنل مدیریت";

    $("#progressTop").addClass("invisible");


    // $('#search').addClass('invisible');
    // $('#masters').addClass('invisible');
    // $('#loading').removeClass('invisible');
    // $('#waitspinner').modal('show');

    // let token = localStorage.getItem('token');

    // let data2 = new FormData();
    // data2.append('token', token);
    // let st = " id != ''";
    // data2.append('if', st);
    // axios.post(Data.mainserver+`getClasses3.php`,data2)
    //     .then(response => {
    //         $('#waitspinner').modal('hide');
    //         if (response.data.hasOwnProperty('data')) {

    //             const {data} = response.data;
    //             $('#masters').removeClass('invisible');

    //             console.log(data);

    //             this.setState({
    //                 classesRef: <Classes2 toast={this.handleToast.bind(this)} data={data} />
    //             })
    //         }
    //         if (response.data.hasOwnProperty('no_item')){
    //             $('#no_item').removeClass('invisible');
    //         }
    //         $('#select_instrument').removeClass('invisible');
    //         $('#loading').addClass('invisible');

    //     })
    //     .catch(error => {
    //         console.log(error);
    //         $('#select_instrument').removeClass('invisible');
    //         $('#loading').addClass('invisible');

    //     });
  }, []);

  return (
    <div className="container-fluid">
      <SideBar li="classespanel" />
      <div className="col-12 bg-light p-4 homee" id="main">
        <div className="d-flex justify-content-between align-items-center flex-md-nowrap border-bottom pb-2 my-3">
          <h3 className="h5 text-center">کلاس ها</h3>

          <form
            onSubmit={() => dispatch(classesActions.empty())}
            className="input-group justify-content-center"
          >
            <Input
              clearable
              bordered
              type="text"
              name="search"
              value={search}
              className="m-2"
              color="secondary"
              placeholder="جست و جو ..."
              helperText={"نام , نام خانوادگی یا شماره تلفن"}
              contentRight={
                <div
                  className="circle-background"
                  onClick={() => dispatch(classesActions.empty())}
                >
                  <BiSearchAlt />
                </div>
              }
              contentClickable={true}
              onChange={(e) =>
                dispatch(classesActions.setSearch(e.target.value))
              }
              size="lg"
            />
            <Spacer y={1} />
          </form>
        </div>
        <Radio.Group
          css={{ alignItems: "center", marginTop: "40px" }}
          orientation="horizontal"
          defaultValue={dayid}
          onChange={changeDay}
          className="row"
        >
          <Radio value={0} color="secondary" size="lg">
            {"شنبه"}
          </Radio>
          <Radio value={1} color="secondary" size="lg">
            {"یک شنبه"}
          </Radio>
          <Radio value={2} color="secondary" size="lg">
            {"دوشنبه"}
          </Radio>
          <Radio value={3} color="secondary" size="lg">
            {"سه شنبه"}
          </Radio>
          <Radio value={4} color="secondary" size="lg">
            {"چهارشنبه"}
          </Radio>
          <Radio value={5} color="secondary" size="lg">
            {"پنج شنبه"}
          </Radio>
        </Radio.Group>
        <InfiniteScroll
          element="div"
          className="row gap-2 mt-4 justify-content-center"
          ref={setMyLoader}
          hasMore={hasMore}
          loadMore={handleLoadMore.bind(this)}
          getScrollParent={() => myRef}
        >
          {articles.map((products, index) => (
            <ClassesPanelList key={index} dayid={dayid} index={index} />
          ))}
        </InfiniteScroll>
        <div
          id="loading"
          className="mr-auto ml-auto mt-2 text-muted text-center"
        >
          <Loading color="secondary" size="xl">
            در حال بارگزاری ...
          </Loading>
        </div>
        {/* <div className="">
                        <div className="section animate__animated animate__zoomIn invisible" id="masters">

                            {classesRef}

                        </div>
                        <div className="section animate__animated animate__zoomIn invisible" id="no_item">

                            <div className="container text-center">

                                <div className="section-title">
                                    <h3>{"موردی یافت نشد"}</h3>

                                </div>

                            </div>
                        </div>
                        <div id="loading" className="d-flex mt-6 justify-content-center animate__animated animate__zoomIn invisible">
                            <h3>درحال بارگذاری ...</h3>
                            <CircularProgress className="mr-3" color="secondary"/>
                        </div>

                    </div> */}
      </div>
    </div>
  );
}

export default ClassesPanel;
